import React from 'react';
import { GoogleLogin as GoogleLoginDeprecate } from 'react-google-login';
import { OAUTH_CLIENT_ID } from '../../../../config';
import useAuth from '../../hooks/useAuth';
import { GoogleOAuthProvider } from '@react-oauth/google';

import ButtonGoogleLogin, { ITokenResaponse } from './ButtonGoogleLogin';
import StyledGoogleButton, { GLogo } from './styles';

interface GoogleButtonProps {
  text?: string;
}

const GoogleButton: React.FC<GoogleButtonProps> = ({ text }) => {
  const { onGoogleAuth } = useAuth();

  const handleOnSuccess = (tokenResponse: ITokenResaponse) => {
    return onGoogleAuth(tokenResponse?.access_token);
  };

  return (
    <>
      <GoogleOAuthProvider clientId={OAUTH_CLIENT_ID as string}>
        <ButtonGoogleLogin text={text} onSuccess={handleOnSuccess} />
      </GoogleOAuthProvider>
      {/* <br />
      <GoogleLoginDeprecate
        clientId={OAUTH_CLIENT_ID}
        render={({ onClick, disabled }) => {
          return (
            <StyledGoogleButton
              onClick={onClick}
              altVersion
              disabled={disabled}
            >
              <GLogo altVersion />
              <span>{text} <small style={{ color: 'orange'}}>Deprecated</small></span>
            </StyledGoogleButton>
          );
        }}
        onSuccess={(res: any) => {
          console.info(res);
          onGoogleAuth(res?.accessToken);
        }}
        onFailure={(res) => {
          console.error(
            '%c🐛 FAIL: res',
            'background: #332167; color: #b3d1f6; font-size: 11px',
            res,
          );
        }}
      /> */}
    </>
  );
};

export default GoogleButton;
